// extracted by mini-css-extract-plugin
module.exports = {"trophyGallery__container":"TrophyGallery_trophy-gallery__container__gCNuS","trophyGallery__container_museumGallery":"TrophyGallery_trophy-gallery__container_museumGallery__eAlnv"};